// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"be9df7c6","845":"05ad2e43","930":"8a5b37fe"}[chunkId] + ".chunk.js";
};